<template>
  <div class="success-wrapper">
    <img src="../../../public/img/xy_success.png" alt="" />
    <p class="success-info">
      <a-icon type="check-circle" theme="filled" style="color:#52C41A" />
      <span>您完成培训确认</span>
    </p>
    <train-item
      style="margin-bottom:24px;"
      :trainData="trainData"
      v-if="trainData"
    ></train-item>
    <a-button
      type="primary"
      shape="round"
      style="height:48px;padding: 0 24px;margin-bottom:8px"
      @click="chooseAgain"
      v-if="reselectable"
      >重新选择培训</a-button
    >
    <p class="tips" v-if="reselectable">每人仅可以操作一次修改</p>
    <p class="tips" v-else>若要更改培训时间，请及时联系hr</p>
  </div>
</template>
<script>
import TrainItem from './TrainItem'
import resultMixin from './resultMixin'
export default {
  components: { TrainItem },
  mixins: [resultMixin],
  data() {
    return {}
  },
  computed: {
    trainData() {
      return (
        this.$store.state.trainConfirm.selectedTrain ||
        this.getTrainFromList() ||
        {}
      )
    },
  },
  created() {
    this.$store.dispatch('trainConfirm/getTrainList', {
      srId: this.$route.query.srId,
    })
  },
  methods: {
    getTrainFromList() {
      const { trainList, feedback } = this.$store.state.trainConfirm
      return trainList.filter(train => train.id === feedback.trainingId)[0]
    },
  },
}
</script>
<style lang="less" scoped>
.success-wrapper {
  background: #f0f2f5;
  text-align: center;
  height: 100%;
  & > img {
    width: 125px;
    margin: 16px 0 12px;
  }
  .success-info {
    margin-bottom: 22px;
    span {
      padding-left: 8px;
      font-size: 16px;
      font-weight: 500;
      color: #333333;
      line-height: 22px;
    }
  }
  .tips {
    font-size: 15px;
    color: #9b9b9b;
    line-height: 21px;
    margin-bottom: 0;
  }
}
</style>
